import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/render/project/src/src/components/layout.js";
import { Link } from 'gatsby';
import Layout from '../components/layout';
import SEO from '../components/seo';
import hero from "../images/hawthorne/hero.webp";
import clients from "../images/hawthorne/clients.webp";
import napolean from "../images/hawthorne/napolean.webp";
import graph from "../images/hawthorne/graph.webp";
import component from "../images/hawthorne/component.webp";
import workshop from "../images/hawthorne/workshop.webp";
import architecture from "../images/hawthorne/architecture.webp";
import board from "../images/hawthorne/board.webp";
import topline from "../images/hawthorne/topline.webp";
import books from "../images/hawthorne/books.webp";
import mtsm from "../images/hawthorne/mtsm.webp";
import guide from "../images/hawthorne/guide.webp";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEO title="Hawthorne Advertising" keywords={['Seraph', 'kumar', 'designer', 'user', 'experience', 'product', 'interaction', 'b2b', 'saas', 'web', 'app', 'platform', 'gatsby', 'application', 'react']} mdxType="SEO" />
    <img height="auto" loading="eager" src={hero} alt="Mockup of web platform." className="hero heroMarginBottom" />
    <h1>{`Designing for Businesses`}</h1>
    <div className="nda"> Content is limited and altered to abide by NDAs </div>
    <h2>{`Hawthorne Advertising`}</h2>
    <p>{`After pioneering the infomercial, Tim Hawthorne founded Hawthorne Advertising.
A strong history and impressive clientele made Hawthorne Advertising a cornerstone in the industry.
I had the honor of designing products for clients like Apple, Nissan, and Nestle.`}</p>
    <img height="auto" loading="lazy" src={clients} alt="Hawthorne's clientele." className="center" />
    <h2>{`Seraph`}</h2>
    <p>{`I was in charge of designing and managing a massive data science that included multiple products.
My team consisted of developers, business intelligence specialists, and data scientists.
I was the sole product designer at Hawthorne, so integration was key to success.`}</p>
    <h2>{`Products`}</h2>
    <p>{`Hawthorne Obelisk was a web app we used to manage our entire backend.
It was used by every department, so it serveed many use-cases and technical proficiencies.
Version 1 launched in Q1 2021.`}</p>
    <p>{`Hawthorne Asterisk was also a web app, but for our clients and client managers.
It was meant to replace our existing reporting tools and dashboards.
Clients and managers could track their performance once Asterisk launches in Q4 2021.`}</p>
    <p>{`When I initiated both projects, I gave them their cute rhyming names. But oh boy are they mouthfuls during meetings.
Try saying Asterisk and Obelisk like 15 times. `}</p>
    <p>{`There were also smaller web apps that filled in the gap between Obelisk and Asterisk.`}</p>
    <img height="auto" loading="lazy" src={topline} alt="Mockup of Asterisk." className="center" />
    <div className="caption">My concept mockup for Asterisk, made in Figma.</div>
    <img height="auto" loading="lazy" src={mtsm} alt="Mockup of a web app." className="center" />
    <div className="caption">My mockup for a smaller web app that reuse's Obelisk's assets.</div>
    <h2>{`Connecting us`}</h2>
    <p>{`Our employees said the backend made them inefficient.
It’s not a great feeling when you have to fight with your tools.
A 30+ year-old tech-stack serving a dozen different departments is bound to rack up UX debt. Designing around that was a Herculean task.`}</p>
    <p>{`But it wasn't impossible. Hawthorne is full of super supportive people.
Leaders from all departments attended my weekly design workshops.
I guideed them through problem generating and problem-solving exercises.`}</p>
    <p>{`It was a rounded way to gain insights and produce solutions considerate of all users.
Workshopping also organically taught people user-centered thinking.`}</p>
    <img height="auto" loading="lazy" src={workshop} alt="Sticky notes from a design workshop." className="center" />
    <div className="caption">Sticky notes after a design workshop I conducted in Miro.</div>
    <h2>{`Test & iterate`}</h2>
    <p>{`All new solutions are boiled down in scope.
Small and fast solutions are integral to good testing and iteration.
It enabled me to quickly whip up high-fidelity prototypes in Figma.
When users think aloud while performing tasks on hi-fi prototypes, they have a lot more to say.
There were also cases where I’d just slack mock-ups to users and ask for general feedback. `}</p>
    <p>{`I conducted continuous exploratory research.
It’s a fancy way of saying I had discussions with users, analyzed our existing tools, and asked our users to teach me how they interacted with the backend.
And that was on top of my regular exploration of design in general.`}</p>
    <img height="auto" loading="lazy" src={board} alt="Sticky notes of my research insights." className="center" />
    <div className="caption">Sticky notes of my research insights, thoughts and inspirations. </div>
    <img height="auto" loading="lazy" src={component} alt="A page from my design system." className="center" />
    <div className="caption">I could iterate fast because of the design system I built in Figma.</div>
    <img height="auto" loading="lazy" src={guide} alt="A sketch for my developers." className="center" />
    <div className="caption">Sometimes I'd draw an explanation of UI and UX concepts for my team.</div>
    <h2>{`Business stories`}</h2>
    <p>{`Unlike Obelisk, Asterisk (I told you it’s a mouthful) didn't run on user research and testing.
I was asked not to involve clients in the design process until Asterisk launches, for reasonable reasons.
It was unfortunate because the abstract goal of creating stories out of data reports was nebulous... at first.`}</p>
    <p>{`I silently observed weekly meetings between clients and client managers.
Our client managers liked spreadsheets, but they didn't like our existing data visualizations.
They thought granular tabular data told engaging stories. Our clients liked data visualizations, but they didn't like our spreadsheets.
They thought concise overviews of progress and trends told engaging stories.`}</p>
    <p>{`They both wanted the same thing, but their disagreement on the medium created disappointment.  `}</p>
    <h2>{`We live in a society`}</h2>
    <p>{`According to statistician Edward Tufte, we as a society are not good with data visualization.
Pie charts have poor UX, bar graphs lie through scale, and we never show what's only necessary.
I poured through Tufte’s books to understand visualizations that satisfy both my user
groups' needs.`}</p>
    <img height="auto" loading="lazy" src={books} alt="Edward Tufte's books." className="center" />
    <div className="caption">These books taught me how to design data visualizations.</div>
    <img height="auto" loading="lazy" src={napolean} alt="Edward Tufte's books." className="center" />
    <div className="caption">Tufte introduced this graph of Napolean's army withering away over time in harsh weather.</div>
    <p>{`Napoleon’s march is our golden standard.
The relationships between multiple granular metrics give rise to concise stories.
It should satisfy both our clients and managers.`}</p>
    <h2>{`In progress`}</h2>
    <p>{`Inspired by Russia’s winters, my team brainstormed and sketched all kinds of intricate graphs.
The client managers were excited by our concepts because they opened doors to more efficient and comprehensive strategizing. `}</p>
    <p>{`Sadly, we discovered that our backend just wasn't able to create these data visualizations.
The hope was that Obelisk would give us the tools we needed to advance our backend to make Asterisk a reality.
At the time, we used Tableau's API to power basic visualizations. `}</p>
    <img height="600px" loading="lazy" src={graph} alt="A sketch of a graph." className="center" />
    <div className="caption">A concept of a data visualization I sketched in Apple Notes.</div>
    <h2>{`Towards the future`}</h2>
    <p>{`User-centered development (is that a thing?) can lead to great product support.
Which is why I stepped up to be the manager.
It turned out we're actually all interested in pursuing tech that improves UX across the board.`}</p>
    <p>{`I introduced lean development practices to the team.
We tested and iterated a new backend architecture that will make Asterisk a data visualization powerhouse.
It’s going to enable processing and connecting interesting points like political data and weather data.`}</p>
    <img height="auto" loading="lazy" src={architecture} alt="Flow of Obelisk." className="center" />
    <div className="caption">This app flow I drew in Lucid Charts shows my team how backend processes work with the frontend.</div>
    <p>{`Because of my development and data-science experience, I was initially bridging team members by communicating their expertise to each other.
But the workshops, passion projects, and our vision for the products made us quite harmonious.`}</p>
    <Link to="/" mdxType="Link">Home</Link>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      